import { render, staticRenderFns } from "./DialogoConfiguracoesSistema.vue?vue&type=template&id=724d7a52&scoped=true&"
import script from "./DialogoConfiguracoesSistema.vue?vue&type=script&setup=true&lang=js&"
export * from "./DialogoConfiguracoesSistema.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724d7a52",
  null
  
)

export default component.exports